import React, { useState } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { confirmBatchShip } from '../../../../services/api/apiBatchShip'
import { message, Modal, Checkbox, Button, Tooltip } from 'antd'
import { listLocal } from '../../../helpers/filtersTable'
import listLineShipBox from '../../../helpers/listLineShipBox'

function BatchShipRow(props) {

    const { item, reload, userRoles, arrSelected, onSelected, batchStatus, boxCarrier } = props
    const {
        id, _id,
        created,
        updated,
        status,
        carrier,
        box_carrier,
        tracking_number,
        shipping_fee,
        shipping_status,
        count_boxes,
        batch_type,
        count_hw_boxes,
        partner_box_status,
        fba_gen_stats
    } = item
    const [showModal, setShowModal] = useState(false)
    const [confirmWarning, setConfirmWarning] = useState([])
    const [forceConfirm, setForceConfirm] = useState(false)

    const handleToggleModal = (e) => {
        e.preventDefault()
        setShowModal(!showModal)
        setForceConfirm(false)
        setConfirmWarning([])
    }

    const _handleConfirmBatchShip = async (id) => {
        const payload = {}
        if(forceConfirm) payload.force = forceConfirm

        try {
            const { data } = await confirmBatchShip(id, payload)
            const { success, message: mess, data: Data } = data
            const { errors } = { ...Data }
            if (success && !errors) {
                message.success('Trạng thái lô confirmed')
                reload()
            } else {
                setConfirmWarning(errors || [])
                !!mess && message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        }
    }

    const _handleReConfirm = async (id) => {
        const payload = {
            confirmed: true
        }
        if(forceConfirm) payload.force = forceConfirm
        try {
            const { data } = await confirmBatchShip(id, payload)
            const { success, message: mess} = data
            if (success) {
                message.success('Trạng thái lô confirmed')
                reload()
            } else {
                !!mess && message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        }
    }

    const checkValue = (value) => {
        return !!value ? value : '-'
    }

    const ShippingCarrierName = (carrier) => {
        if (!!carrier) {
            const mappingCarriers = [
                ...listLocal,
                { value: 'usps_mn_ib_blue', name: 'USPS MN/IB Blue' },
                { value: 'ib_blue_usps_mn', name: 'IB Blue/USPS MN' },
            ]
            const shippingName = mappingCarriers.filter(item =>!!item.value && item.value === carrier)
            return !!shippingName.length ? shippingName[0].name : ''
        }
    }

    const _detectChecked = () => {
        return Array.isArray(arrSelected) && !!arrSelected.find(i => i._id === _id)
    }

    const _handleChange = () => {
        const isChecked = _detectChecked()

        if (typeof onSelected === 'function') {
            onSelected(_id, !isChecked)
        }
    }

    const _handleChangeForceConfirm = (e) => {
        setForceConfirm(e.target.checked)
    }

    const adminPermission = !!userRoles.length && userRoles.includes('fac_admin')
    const ffmPermission = !!userRoles.length && userRoles.includes('fac_ffm')
    const isChecked = _detectChecked()

    return (
        <tr>
            {
                batchStatus === 'confirmed' && listLineShipBox.includes(boxCarrier) && 
                <td className='SelectedCheckbox'>
                    <Checkbox checked={isChecked} onChange={_handleChange}/>
                </td>
            }
            <td>
                <div className='d-flex'>
                    <Link to={`/batch-ship/${_id}`} className='mr-2'>{id}</Link>
                    {batch_type === 'FBA' &&
                        <button type="button" className="ant-btn TagFBA ant-btn-primary ant-btn-sm">
                            <span>FBA</span>
                        </button>
                    }
                </div>
            </td>
            <td>{moment(created).format('HH:mm DD/MM/YYYY')}</td>
            <td>{moment(updated).format('HH:mm DD/MM/YYYY')}</td>
            <td
                style={{ color: (status === 'open' ? '#DC3545' : '#28A745') }}
            >
                {status}
            </td>
            <td>{checkValue(ShippingCarrierName(box_carrier))}</td>
            <td>{count_boxes}</td>
            {
                batch_type === 'FBA'
                    ? (
                        // Lô FBA: thùng gen thành công / gen lỗi / tổng số thùng
                        <td>
                            {fba_gen_stats
                                ? <Tooltip
                                    title='Thùng gen thành công / Thùng gen lỗi / Tổng số thùng'
                                    overlayStyle={{ maxWidth: 'none' }}
                                    overlayInnerStyle={{ whiteSpace: 'nowrap' }}
                                >
                                    <span className='font-weight-bold' style={{ cursor: 'help' }}>
                                        <span style={{ color: 'green' }}>{fba_gen_stats.success || 0}</span>
                                        <span>/ </span>
                                        <span style={{ color: 'red' }}>{fba_gen_stats.error || 0}</span>
                                        <span>/ {fba_gen_stats.total || 0}</span>
                                    </span>
                                </Tooltip>
                                : '-'}
                        </td>
                    )
                    : (
                        <td className={`${partner_box_status && (partner_box_status === 'done' || partner_box_status === 'error') ? count_hw_boxes === count_boxes ? 'box-create-success' : 'box-create-unsuccess' : ''}`}>{partner_box_status && (partner_box_status === 'done' || partner_box_status === 'error') ? `${count_hw_boxes ? count_hw_boxes : '0'}/${count_boxes ? count_boxes : '0'}` : '-'}</td>
                    )
            } 
            <td>
                {checkValue(tracking_number)}
            </td>
            <td>{checkValue(carrier)}</td>
            <td>{checkValue(shipping_status)}</td>
            {(!!adminPermission || !!ffmPermission) &&
                <td>{checkValue(shipping_fee)}</td>
            }
            <td>
                {status === 'confirmed' && shipping_status !== 'delivered' && (!!adminPermission || !!ffmPermission) &&
                    <Link
                        to={`/batch-ship/${_id}`}
                        className='Action'
                    >
                        Update ship info
                    </Link>
                }
                {status === 'open' && shipping_status !== 'delivered' &&
                    <>
                        <Link
                            className='Action mx-1'
                            onClick={handleToggleModal}
                            to=''
                        >
                            Confirm
                        </Link>|
                        <Link
                            className='Action mx-1'
                            to={`/batch-ship/${_id}`}
                        >
                            Edit
                        </Link>
                        <Modal
                            title='Xác nhận thông tin lô ship'
                            visible={showModal}
                            // onOk={() => confirmWarning.length <= 0 ? _handleConfirmBatchShip(_id) : _handleReConfirm(_id)}
                            onCancel={handleToggleModal}
                            // okButtonProps={{ disabled: (confirmWarning.length > 0 && !confirmWarning.every(i => i.type === 'warning')) }}
                            footer={
                                <div style={{ display: "flex", justifyContent: 'flex-end', alignItems: 'center'}}>
                                    {
                                        box_carrier === 'SB_FAST' &&
                                        <span className='force-confirm' style={{ marginRight: '8px' }}>
                                            <Checkbox
                                                checked={forceConfirm}
                                                onChange={_handleChangeForceConfirm}
                                            >
                                            </Checkbox>
                                            <label style={{ fontWeight: 'bold', margin: '0 0 0 8px' }}>Force confirm</label>
                                        </span>
                                    }
                                    
                                    <div>
                                        <Button onClick={handleToggleModal}>Cancel</Button>
                                        <Button type="primary" onClick={() => confirmWarning.length <= 0 ? _handleConfirmBatchShip(_id) : _handleReConfirm(_id)} disabled={confirmWarning.length > 0 && !confirmWarning.every(i => i.type === 'warning')}>OK</Button>
                                    </div>
                                </div>
                            }
                        >
                            {confirmWarning.length <= 0 &&
                                <label className='text-danger'>
                                    Lô ship '{id}' sẽ được chuyển sang trạng thái confirmed!!!
                                </label>
                            }
                            {confirmWarning.length > 0 &&
                                confirmWarning.map(i =>
                                (<label
                                    className={(i.type === 'error' ? 'text-danger' : 'text-warning') + ' w-100 mt-1'}
                                    style={{ whiteSpace: "pre-line" }}
                                >
                                    <i className={i.type === 'error' ? 'icon-cancel-circle2' : 'icon-warning22'} /> {i.msg}
                                </label>)
                                )
                            }
                        </Modal>
                    </>
                }
            </td>
        </tr>
    )
}

export default BatchShipRow